var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedPlaylistIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.04199 2.32499C6.04199 1.71306 6.53769 1.21509 7.14681 1.21509H18.4852C19.0943 1.21509 19.59 1.71306 19.59 2.32499V18.5152C19.59 19.1271 19.0943 19.6251 18.4852 19.6251H17.7662",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M2.69043 5.04545C2.69043 4.43352 3.18612 3.93555 3.79525 3.93555H15.1336C15.7427 3.93555 16.2384 4.43352 16.2384 5.04545V20.2357C16.2384 20.8476 15.7427 21.3456 15.1336 21.3456H14.4146",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55879 23.4704H12.5351C13.1247 23.4704 13.6046 22.9963 13.6046 22.4136V6.9319C13.6046 6.34926 13.1247 5.87512 12.5351 5.87512H1.55879C0.969122 5.87512 0.489258 6.34926 0.489258 6.9319V22.4136C0.489258 22.9963 0.969122 23.4704 1.55879 23.4704ZM9.76998 14.5162L5.43761 11.6961C5.3924 11.6664 5.33734 11.6649 5.2908 11.692C5.23787 11.7227 5.20312 11.7841 5.20312 11.8536V17.4923C5.20312 17.5617 5.23769 17.6228 5.29072 17.6534C5.31307 17.6663 5.33701 17.6727 5.36103 17.6727C5.38777 17.6727 5.41464 17.6648 5.43875 17.6491L9.76957 14.83C9.81855 14.7981 9.85017 14.7387 9.85017 14.673C9.85017 14.6072 9.81855 14.5479 9.76998 14.5162Z",
    fill: "white",
    fillOpacity: 0.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedPlaylistIcon);
export default __webpack_public_path__ + "static/media/feed-playlist-icon.3b55943e.svg";
export { ForwardRef as ReactComponent };